import { render, staticRenderFns } from "./Sidebarmenu.vue?vue&type=template&id=7f71772b&scoped=true&"
import script from "./Sidebarmenu.vue?vue&type=script&lang=js&"
export * from "./Sidebarmenu.vue?vue&type=script&lang=js&"
import style0 from "./Sidebarmenu.vue?vue&type=style&index=0&id=7f71772b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f71772b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VAppBarNavIcon,VAvatar,VDivider,VFlex,VIcon,VImg,VNavigationDrawer})
